



























import Vue from "vue";
import { mapGetters } from "vuex";
import { functions } from "@/plugins/firebase";
import { User, UserFile } from "@/store/types";
import UserImage from "@/components/UserImage.vue";

export default Vue.extend({
  name: "AdminUser",
  components: { UserImage },
  data: () => ({
    userProfile: {} as User | null
  }),

  mounted: async function() {
    const result = await functions.httpsCallable("getUser")(
      this.$route.params.userUid
    );
    this.userProfile = result.data.user as User;
    if (this.userProfile.uid) {
      await this.$store.dispatch(
        "files/bindUserAdminFiles",
        this.userProfile.uid
      );
    }
  },
  destroyed() {
    this.$store.dispatch("files/unbindUserAdminFiles");
  },
  computed: {
    ...mapGetters("users", ["fullName", "isAuthenticated", "avatarUrl"]),
    email() {
      return this.$store.state.users.user.email;
    },
    allFiles() {
      return this.$store.state.files.userAdminFiles.filter(
        (f: UserFile) => f.downloadURL
      );
    }
  },
  methods: {}
});
